var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5751 6.82634C14.7288 8.87658 14.6861 9.69466 14.4476 11.7368C14.2785 13.1809 13.1183 14.3128 11.682 14.4741C9.23385 14.7455 6.76317 14.7455 4.31497 14.4741C2.8779 14.3128 1.7177 13.1809 1.54937 11.7368C1.25958 9.25333 1.25958 6.7446 1.54937 4.26116C1.7177 2.81622 2.87869 1.68512 4.31497 1.52387C6.76317 1.25246 9.23385 1.25246 11.682 1.52387M14.4476 2.66667L7.99433 9.55576L5.26491 6.82634",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/Checkmark.0e03cb068299e8f875f42e2cffa4db60.svg";
export { ForwardRef as ReactComponent };